import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import {useEffect, useMemo, useState, useRef} from 'react'
import {fetchData, toasterrormsg, toastsuccessmsg} from '../../../reusable'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import 'react-datepicker/dist/react-datepicker.css'
import {Link} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import Swal from 'sweetalert2'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit, faTrash} from '@fortawesome/free-solid-svg-icons'
import { Tr } from '../../../_metronic/i18n/Tr'

// import {PageTitle} from '../../../_metronic/layout/core'
// import {useIntl} from 'react-intl'

const Popup = (props: any) => {
    // add / edit facility states

    const [enName, setEnName] = useState(props.passdata.data.en_name || '')
    const [ruName, setRuName] = useState(props.passdata.data.ru_name || '')
    const [uzName, setUzName] = useState(props.passdata.data.uz_name || '')
    const [error, setError] = useState(Object)
    const [addloader, setaddLoader] = useState(false)
    const [disable, setDisable] = useState(false)

    const saveTravellerIdtype = async () => {
      setDisable(true)

      if (props.passdata.travelleridtypeId) {
        var param2: any = {
          id: props.passdata.travelleridtypeId,
          enName: enName.trim(),
          ruName: ruName.trim(),
          uzName: uzName.trim(),
        }

        var res2 = await fetchData('admin/addedittravelleridtype', param2)
      
        if (res2.status == '200') {
          toastsuccessmsg('Property Type Updated Successfully')

          setDisable(false)
          props.onHide()
        } else {
          setaddLoader(false)
          setDisable(false)
        }
      } else {
        var param: any = {
          enName: enName.trim(),
          ruName: ruName.trim(),
          uzName: uzName.trim(),
        }

        var res = await fetchData('admin/addedittravelleridtype', param)
        if (res.status == '200') {
          toastsuccessmsg('Property Type Added Successfully')

          // setaddLoader(false)
          setDisable(false)
          props.onHide()
        } else {
          setaddLoader(false)
          setDisable(false)
          toasterrormsg(res.message)
        }
      }
    }

    const validate = () => {
      var errotmp: any = {}
      var err = 0
      if (enName.trim() == '' || enName.trim() == null || enName.trim() == undefined) {
        errotmp['enNameError'] = 'Property Type English Name Required'
        err = 1
      } else if (enName.trim().length > 50) {
        errotmp['enNameError'] = 'Property Category English Name Is Too Large'
        err = 1
      } else if (!enName.match(/^[A-Za-z\s&]+$/)) {
        errotmp['enNameError'] = 'Enter Valid Property Type English Name'
        err = 1
      } else if (ruName.trim() == '' || ruName.trim() == null || ruName.trim() == undefined) {
        errotmp['ruNameError'] = 'Property Type Russian Name Required'
        err = 1
      } else if (ruName.trim().length > 50) {
        errotmp['ruNameError'] = 'Property Type Russian Name Is To Large'
        err = 1
      } else if (uzName.trim() == '' || uzName.trim() == null || uzName.trim() == undefined) {
        errotmp['uzNameError'] = 'Property Type Uzbek Name Required'
        err = 1
      } else if (uzName.trim().length > 50) {
        errotmp['uzNameError'] = 'Property Type Uzbek Name Is To Large'
        err = 1
      } else {
      }

      setError(errotmp)
      if (err == 0) {
        saveTravellerIdtype()
      }
    }


    // add / edit facility state end
    return (
      <Modal
        {...props}
        size='xl'
        aria-labelledby='contained-modal-title-hcenter'
        dialogClassName='maxwidth1000px'
        centered
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className='d-flex align-items-center col-10'>
            <h4 className='fw-bold'>{enName ? 'Edit' : 'Add'} Included</h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            className='stepper stepper-links d-flex flex-column'
            id='kt_create_account_stepper'
            data-kt-stepper='true'
          >
            <div className='mx-auto w-100 py-10 row' id='kt_create_account_form'>
              <div className='col-lg-4 col-xl-4'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  English Name
                </label>
                <input
                  type='text'
                  name='includedName'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder='English Name'
                  value={enName}
                  onChange={(e: any) => setEnName(e.target.value)}
                ></input>
                <label className='text-danger'>{error.enNameError || ''}</label>
              </div>
              <div className='col-lg-4 col-xl-4'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  Russian Name
                </label>
                <input
                  type='text'
                  name='includedName'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder='Russian Name'
                  value={ruName}
                  onChange={(e: any) => setRuName(e.target.value)}
                ></input>
                <label className='text-danger'>{error.ruNameError || ''}</label>
              </div>
              <div className='col-lg-4 col-xl-4'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Uzbek Name</label>
                <input
                  type='text'
                  name='includedName'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder='Uzbek Name'
                  value={uzName}
                  onChange={(e: any) => setUzName(e.target.value)}
                ></input>
                <label className='text-danger'>{error.uzNameError || ''}</label>
              </div>

              {/* action button start */}
              <div className={`d-flex pt-15 justify-content-center`}>
                <button
                  type='button'
                  className={`btn btn-lg btn-light-success me-3`}
                  onClick={props.onHide}
                >
                  Cancel
                </button>

                <button
                  type='button'
                  disabled={disable}
                  className={`btn btn-lg btn-success monthBtn me-3`}
                  onClick={() => validate()}
                >
                  {!disable && 'Save'}
                  {disable && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* action button end */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }

function ViewTravellerIdType() {
  const  t= Tr()
  const [showPopup, setShowPopup] = useState(false)
  const [includedList, setIncludedList] = useState([])
  const [orgIncludedList, setOrgIncludedList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)

  // Initial state setup
  const [passdata, setPassData] = useState<{
    travelleridtypeId: any
    data: {en_name: any; ru_name: any; uz_name: any}
  }>({
    travelleridtypeId: '',
    data: {en_name: '', ru_name: '', uz_name: ''},
  })

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: 'English Name',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.en_name}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.en_name),
      },
      {
        name: 'Russian Name',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.ru_name}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.ru_name),
        filter: true,
      },
      {
        name: 'Uzbek Name',
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.uz_name}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.uz_name),
        filter: true,
      },
      {
        name: 'Action',
        cell: (row: any) => (
          <>
            <button
              className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light'
              title='Edit'
              onClick={() => {
                const trimmedData = {
                  en_name: row.en_name?.trim() || '',
                  ru_name: row.ru_name?.trim() || '',
                  uz_name: row.uz_name?.trim() || '',
                }

                setPassData({travelleridtypeId: row.travelleridtypeId, data: trimmedData})
                setShowPopup(true)
              }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </button>

            <button
              className='btn btn-icon btn-wave waves-effect waves-light btn-sm btn-primary-light me-2'
              title='delete'
              onClick={() => deleteTravellerIdTypeId(row.travelleridtypeId)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </>
        ),
        width: '140px',
      },
    ],
    [t]
  )

  const deleteTravellerIdTypeId = async (travelleridtypeId: any) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You Want To Delete This Property Type!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      
      if (result.isConfirmed) {

          var tmp2 = sessionStorage.getItem('admin')
          // Step 2: Check if the item is not null
          if (tmp2) {
            // Step 3: Parse the JSON string
            var adminData = JSON.parse(tmp2)
            // Step 4: Access the adminId
            var adminId = adminData.adminId
          }

        try {
          var param: any = {
            travelleridtypeId: travelleridtypeId,
            adminId: adminId
          }

          const response = await fetchData('admin/deletetravelleridtype', param)

          if (response.status == '200') {
            toastsuccessmsg(response.message)
            travellerIdTypeListApiCall()
          } else {
            toasterrormsg(response.message)
          }
        } catch (error) {
          toasterrormsg('An error occurred while processing your request.')
        }
      }
    })
  }

  // call cuisine list api
  const travellerIdTypeListApiCall = async () => {
    var response: any = await fetchData('admin/travelleridtypelist', Object)

    if (response.status == '200') {
      setIncludedList(response.data)
      setOrgIncludedList(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | Included'
    travellerIdTypeListApiCall()
  }, [])

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.fncareserch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder='Search Traveller idtype'
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end col-xl-8 ' data-kt-user-table-toolbar='base'>
          <button
            type='button'
            className='btn btn-success monthBtn'
            onClick={() => setShowPopup(true)}
          >
            <KTIcon iconName='plus' className='fs-2' />
            Add Traveller Idtype
          </button>
          {/* end::Add Department */}
        </div>
      </div>
    )
  }

  //search function
  const includedSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text === '' || text == null || text === undefined) {
      setIncludedList(orgIncludedList)
    } else {
      const tmp: any = orgIncludedList.filter((item: any) => {
        const multiSelectLabel = item.multiSelect ? 'Multi Select' : 'Single Select'
        const valuesEnNames = item.values.map((value: any) => value.en_name.toLowerCase())

        return (
          (item.en_name != null &&
            item.en_name !== '' &&
            item.en_name.toLowerCase() === text.toLowerCase()) ||
          (item.en_name != null &&
            item.en_name !== '' &&
            item.en_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.ru_name != null &&
            item.ru_name !== '' &&
            item.ru_name.toLowerCase() === text.toLowerCase()) ||
          (item.ru_name != null &&
            item.ru_name !== '' &&
            item.ru_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.uz_name != null &&
            item.uz_name !== '' &&
            item.uz_name.toLowerCase() === text.toLowerCase()) ||
          (item.uz_name != null &&
            item.uz_name !== '' &&
            item.uz_name.toLowerCase().includes(text.toLowerCase())) ||
          multiSelectLabel.toLowerCase().includes(text.toLowerCase()) ||
          valuesEnNames.some((enName: string) => enName.includes(text.toLowerCase()))
        )
      })
      setIncludedList(tmp)
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orgIncludedList.length > 0 ? (
              <>
                <DataTable
                  columns={column}
                  data={includedList}
                  // progressPending={isLoading}
                  pagination
                  paginationServer={false}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader search={searchTerm} isfoc={focus} fncareserch={includedSearch} />
                  }
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column my-10 py-20'>
                    <h2 className='fs-2x fw-bold mb-10'>Welcome To Included</h2>
                    {/* <h6 className='text-secondary'>List of your household members</h6> */}
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold mb-10'>There are no Included</p>
                  <Link
                    to='#'
                    className='btn btn-success monthBtn'
                    onClick={() => setShowPopup(true)}
                  >
                    Add Traveller Idtype
                  </Link>
                  <br />
                  {/* <img className="mw-100 mh-300px" alt="" src={toAbsoluteUrl("/media/illustrations/sketchy-1/2.png")} /> */}
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {showPopup && (
          <Popup
            show={showPopup}
            passdata={passdata}
            onHide={() => {
            setPassData({travelleridtypeId: '', data: {en_name: '', ru_name: '', uz_name: ''}})
              setShowPopup(false)
                        travellerIdTypeListApiCall()

            }}
          />
        )}
      </div>
    </>
  )
}

export default ViewTravellerIdType
